import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect, useRef } from 'react';

const ELFSIGHT_WIDGET_CLASS = 'elfsight-app-40a72e46-54ca-4289-8839-eef281cb505c';

export default function ElfsightGoogleReviews() {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return;

    let timeoutId: number | undefined;
    let frameId: number | undefined;

    const scheduleRefresh = () => {
      if (timeoutId) window.clearTimeout(timeoutId);
      if (frameId) window.cancelAnimationFrame(frameId);

      timeoutId = window.setTimeout(() => {
        frameId = window.requestAnimationFrame(() => {
          ScrollTrigger.refresh();
        });
      }, 120);
    };

    const ResizeObserverConstructor = window.ResizeObserver;
    const resizeObserver = new ResizeObserverConstructor(() => {
      scheduleRefresh();
    });

    const mutationObserver = new MutationObserver(() => {
      scheduleRefresh();
    });

    resizeObserver.observe(container);
    mutationObserver.observe(container, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });

    const delayedRefreshIds = [250, 750, 1500].map((delay) =>
      window.setTimeout(() => {
        scheduleRefresh();
      }, delay),
    );

    scheduleRefresh();

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();

      if (timeoutId) window.clearTimeout(timeoutId);
      if (frameId) window.cancelAnimationFrame(frameId);

      delayedRefreshIds.forEach((id) => window.clearTimeout(id));
    };
  }, []);

  return <div ref={containerRef} className={ELFSIGHT_WIDGET_CLASS} />;
}
